
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"47","height":"47","viewBox":"0 0 47 47","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"23.5","cy":"23.5","r":"23","stroke":"#4D4D4F"}}),_c('path',{attrs:{"d":"M19 21L23 12C23.7956 12 24.5587 12.3161 25.1213 12.8787C25.6839 13.4413 26 14.2044 26 15V19H31.66C31.9499 18.9967 32.2371 19.0565 32.5016 19.1752C32.7661 19.2939 33.0016 19.4687 33.1919 19.6875C33.3821 19.9063 33.5225 20.1638 33.6033 20.4423C33.6842 20.7207 33.7035 21.0134 33.66 21.3L32.28 30.3C32.2077 30.7769 31.9654 31.2116 31.5979 31.524C31.2304 31.8364 30.7623 32.0055 30.28 32H19M19 21V32M19 21H16C15.4696 21 14.9609 21.2107 14.5858 21.5858C14.2107 21.9609 14 22.4696 14 23V30C14 30.5304 14.2107 31.0391 14.5858 31.4142C14.9609 31.7893 15.4696 32 16 32H19","stroke":"#4D4D4F","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    